import { inboxStateName } from '../../../../components/inbox/inbox.state';
import { UserPermissions } from '../../../user/user.roles';

export const InboxTab = {
  id: 'inbox',
  ref: inboxStateName,
  text: 'navbar.link.inbox.title',
  requiresAuth: true,
  permissions: [
    UserPermissions.Inbox.newAndDoneDocuments,
    UserPermissions.Inbox.rejectedDocumentsWithoutIban
  ],
};
